<template>
  <v-container>
    <v-row>
      <v-overlay :value="openViewProfile" transition="scale-transition" origin="center center" light>
        <v-toolbar color="transparent" height="60" elevation="0" dark>
          <v-toolbar-title class="text-body-1"></v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon medium @click="openViewProfile = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <ViewProfile :userdata="profileDetail" />
      </v-overlay>
      <v-col cols="12" lg="3">
        <UserNavigation />
      </v-col>
      <v-col cols="12" lg="9">
        <v-card class="mx-auto">
          <v-toolbar color="secondary" dark height="45">
            <v-toolbar-title class="text-body-1">
              <v-icon left class="mr-2">mdi-account</v-icon>
              {{ $t("PANEL.USER.LIST.TITLE") }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <AddUser /> -->
          </v-toolbar>

          <div v-show="userList.length === 0">
            <v-progress-linear color="#4663cf" indeterminate height="5" absolute v-show="true"></v-progress-linear>
            <v-list-item class="py-0">
              <v-list-item-content class="py-5 text-center">
                <span class="text-overline">{{ $t("PANEL.USER.LIST.LOADING_LIST") }}</span>
              </v-list-item-content>
            </v-list-item>
          </div>
          <div class="pa-2">
            <!--          <v-list-item-->
            <!--            v-show="userList.length > 0"-->
            <!--            class="py-0"-->
            <!--          >-->
            <!--            <v-list-item-avatar class="my-0">-->
            <!--              <v-subheader class="text-center">-->
            <!--                #-->
            <!--              </v-subheader>-->
            <!--            </v-list-item-avatar>-->

            <!--            <v-list-item-content class="py-0">-->
            <!--              <v-subheader class="px-0">-->
            <!--                Kullanıcı-->
            <!--              </v-subheader>-->
            <!--            </v-list-item-content>-->

            <!--            <v-list-item-content class="py-0">-->
            <!--              <v-subheader class="px-0">-->
            <!--                Eposta-->
            <!--              </v-subheader>-->
            <!--            </v-list-item-content>-->

            <!--            <v-list-item-content class="py-0">-->
            <!--              <v-subheader class="px-0">-->
            <!--                Grup-->
            <!--              </v-subheader>-->
            <!--            </v-list-item-content>-->

            <!--            <v-list-item-content class="py-0">-->
            <!--              <v-subheader class="px-0 text-center">-->
            <!--                İşlemler-->
            <!--              </v-subheader>-->
            <!--            </v-list-item-content>-->

            <!--          </v-list-item>-->
            <template v-for="(user, userKey) in userList">
              <v-row no-gutters :key="user.id">
                <v-col cols="12" sm="6" md="3" class="d-flex justify-start align-center mb-2 mb-sm-0">
                  <div class="mr-2">
                    <v-avatar v-if="!user.avatar" color="primary" size="38">
                      <v-icon dark size="20">
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                    <v-img v-else :alt="`${user.name} avatar`" :src="user.avatar"></v-img>
                  </div>
                  <v-list-item-title v-text="user.name"></v-list-item-title>
                </v-col>

                <v-col cols="12" sm="6" md="3" class="d-flex align-center text-body-2 font-weight-light">
                  <v-icon size="18" left>mdi-email</v-icon>
                  {{ user.email }}
                </v-col>

                <v-col cols="12" sm="6" md="3" class="d-flex align-center text-overline font-weight-light">
                  <div v-if="user.group">
                    <v-icon size="20">mdi-account-group</v-icon>
                    {{ user.group }}
                  </div>
                  <div v-else class="text-capitalize">
                    <v-icon size="20">mdi-account-group</v-icon>
                    Grup Yok
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <div class="d-flex justify-start">
                    <div :key="ekey" v-for="(event, ekey) in userNavEvents">
                      <v-tooltip bottom>
                        <!-- <div v-if="event.link === 'delete' && user.email === authUser.email"></div> -->
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            :class="[user.email === authUser.email && event.link === 'delete' ? 'd-none' : '']"
                            class="mr-2 text-overline"
                            elevation="0"
                            fab
                            small
                            light
                            color="#ddd"
                            v-bind="attrs"
                            v-on="on"
                            @click="events(event.link, user.id)"
                          >
                            <v-icon v-show="event.link === 'edit'">
                              mdi-account-edit
                            </v-icon>
                            <v-icon v-show="event.link === 'view'">
                              mdi-account-search
                            </v-icon>
                            <v-icon v-show="event.link === 'delete'">
                              mdi-account-cancel
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ event.name }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="py-2" v-if="userList.length - 1 !== userKey">
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </template>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="userDeleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          {{ $t("PANEL.USER.LIST.WARN") }}
        </v-card-title>
        <v-card-text>
          {{ $t("PANEL.USER.LIST.WARN_DELETE_USER_TEXT") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="userDeleteDialog = false">
            {{ $t("PANEL.USER.LIST.WARN_CANCEL_BTN") }}
          </v-btn>
          <v-btn color="green darken-1" text :loading="userDeleteLoading" @click="deleteUser()">
            {{ $t("PANEL.USER.LIST.WARN_YES_BTN") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import AddUser from '@/components/Settings/UserOperations/AddUser';
import ViewProfile from "@/components/Settings/UserOperations/ViewProfile";
import UserNavigation from "@/components/Settings/UserOperations/UserNavigation";
import { mapState } from "vuex";

export default {
  name: "SystemUsers",
  components: {
    // AddUser,
    ViewProfile,
    UserNavigation
  },
  data() {
    return {
      openViewProfile: false,
      profileDetail: [],
      userDeleteID: "",
      userDeleteDialog: false,
      userDeleteLoading: false
    };
  },
  computed: {
    ...mapState({
      userList: state => state.User.UserList.userList || [],
      userNavEvents: state => state.systemTree.panel_settings.child.user_management.child.user_list.child || [],
      authUser: state => state.User.UserLogin.authUser
    })
  },
  methods: {
    events(type, id) {
      switch (type) {
        case "edit":
          this.editUser(id);
          break;
        case "view":
          this.getProfileDetail(id);
          break;
        case "delete":
          this.deleteUserDialog(id);
          break;
      }
    },
    editUser(id) {
      this.$router.push("/settings/user-management/edit-user/" + id);
    },
    getProfileDetail(userId) {
      this.$store
        .dispatch("User/UserDetail/getUserDetail", userId)
        .then(res => {
          this.profileDetail = res.data;
        })
        .then(() => {
          this.openViewProfile = true;
        });
    },
    deleteUserDialog(userID) {
      this.userDeleteDialog = true;
      this.userDeleteID = userID;
    },
    deleteUser() {
      this.$store.dispatch("User/UserList/deleteUser", this.userDeleteID).then(res => {
        if (res.status === 200) {
          this.$snotify.success(this.$t("PANEL.USER.NOTIFY.USER_DELETE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.userDeleteDialog = false;
        this.userDeleteLoading = false;
      });
    }
  },
  created() {
    this.$store.dispatch("User/UserList/getUserList");
  }
};
</script>
